import { actions as formActions } from 'react-redux-form'



import { FilterHandler } from './FilterHandler'




class ToggleFilterHandler extends FilterHandler {
  setFormValue = searchFilterFormName => {
    const isSingular = !!this.filter.options

    const newOpts = isSingular
      ? this.filter.options
          ?.flatMap(opt => {


            return this.filter.value.includes(opt.id) ? [opt.id] : []
          })
          .reduce((acc, curr) => ((acc[curr] = true), acc), {})
      : this.filter.value


    /*
     * console.log("NEW OPTS", newOpts)
     *
     * console.log(`${searchFilterFormName}.${this.filter.id}`, this.filter.value)
     */
    return formActions.change(`${searchFilterFormName}.${this.filter.id}`, newOpts)
  }

  shouldSetParam = value => {
    const toSet = !!value


    return toSet
  }
}

export { ToggleFilterHandler }
